import type { PriceListResource } from "@exonn/js-sdk";
import type { TFunction } from "i18next";
import { formatDate } from "@exonn/utils";
import { getResourceFieldTranslation } from "src/system/getResourceFieldOptions.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { PriceListStatus } from "src/admin/forms/price-list/shared/types.ts";

export const formatPriceListDateRange = ({
  priceList,
  t,
}: {
  priceList: PriceListResource;
  t: TFunction;
}) => {
  const from =
    priceList.active_from && formatDate(String(priceList.active_from));
  const to = priceList.active_to && formatDate(String(priceList.active_to));
  const range = [from, to] as const;

  if (priceList.is_active) {
    const end = from && to ? " " + range.join(" - ") : "";
    return (
      "(" +
      getResourceFieldTranslation({
        resource: ResourceEnum.PriceList,
        field: "status",
        t,
        type: "option_label",
        value: PriceListStatus.Active,
      }) +
      end +
      ")"
    );
  }
  return (
    "(" +
    getResourceFieldTranslation({
      resource: ResourceEnum.PriceList,
      field: "status",
      t,
      type: "option_label",
      value: PriceListStatus.Inactive,
    }) +
    ")"
  );
};
